<template>
  <div class="s_submit_content">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>收支</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/invoicing', query:{activeName} }">开票申请</el-breadcrumb-item>
          <el-breadcrumb-item>{{type=='view' ? '查看' : '退回'}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-tabs v-model="active" type="card" @tab-click="handleClick" class="s_tabs_box" v-if="type!='view'">
        <el-tab-pane :disabled="loading" label="流程信息" name="first"></el-tab-pane>
        <el-tab-pane :disabled="loading" label="工作流" name="second"></el-tab-pane>
        <el-tab-pane :disabled="loading" label="操作记录" name="third"></el-tab-pane>
      </el-tabs>
      <div class="p_employee_box" v-if="active == 'first' && isOver" v-loading="loading">
        <div class="p_employee_list">
          <div class="r_edit_title">
            <div class="line_box"></div>基础信息
          </div>
          <div class="p_employee_form">
            <div class="p_employee_item">
              <p class="emp_txt">开票申请编号:</p>
              <div class="emp_form_txt">
                {{baseInfo.invoiceNo}}
              </div>
            </div>
            <div class="p_employee_item">
              <!-- 项目或部门 -->
              <p class="emp_txt">开票项目/部门:</p>
              <div class="emp_form_txt">
                {{baseInfo.ownershipName}}
              </div>
            </div>
            <div class="p_employee_item">
              <p class="emp_txt">状态:</p>
              <div class="emp_form_txt">
                {{baseInfo.status}}
              </div>
            </div>
            <div class="p_employee_item">
              <p class="emp_txt">申请人:</p>
              <div class="emp_form_txt">
                {{baseInfo.applicant}}
              </div>
            </div>
            <div class="p_employee_item">
              <p class="emp_txt">电话:</p>
              <div class="emp_form_txt">
                {{baseInfo.invoiceRequisitionViewList[0].telephone}}
              </div>
            </div>
            <div class="p_employee_item">
              <p class="emp_txt">申请时间:</p>
              <div class="emp_form_txt">
                {{baseInfo.applicationTime}}
              </div>
            </div>
            <!-- <div class="p_employee_item">
              <p class="emp_txt">退回人:</p>
              <div class="emp_form_txt">
                {{baseInfo.dtEntryDate}}
              </div>
            </div>
            <div class="p_employee_item">
              <p class="emp_txt">退回时间:</p>
              <div class="emp_form_txt">
                {{baseInfo.dtEntryDate}}
              </div>
            </div>
            <div class="p_employee_item">
              <p class="emp_txt">退回备注:</p>
              <div class="emp_form_txt">
                {{baseInfo.dtEntryDate}}
              </div>
            </div> -->
          </div>
          <!-- 发票开具申请单 -->
          <div class="flex aic print_box">
            <el-button type="text" @click="printClick('printBox','')">打印</el-button>
          </div>
          <div class="com_form_box">
            <div id="printBox">
              <div class="centerTitle">发票开具申请单</div>
              <table width="100%" border="0" cellspacing="1" cellpadding="4" class="tabtop form_table" align="center">
                <tr>
                  <td class="btbg font-center">*合伙人</td>
                  <td>{{appInfo.partner}}</td>
                  <td class="btbg font-center">*业务员</td>
                  <td>{{appInfo.salesman}}</td>
                  <td class="btbg font-center">*开票申请人</td>
                  <td colspan="3">{{appInfo.applicant}}</td>
                </tr>
                <tr>
                  <td class="btbg font-center">*服务部门</td>
                  <td>{{appInfo.serviceDepartment}}</td>
                  <td class="btbg font-center">*客服</td>
                  <td>{{appInfo.customerService}}</td>
                  <td class="btbg font-center">*法务主体</td>
                  <td colspan="3">{{appInfo.strLegalsubName}}</td>
                </tr>
                <tr>
                  <td class="btbg font-center">*客户名称</td>
                  <td colspan="4">{{appInfo.strCustShortName}}</td>
                  <td colspan="3">纳税人识别号：{{appInfo.ratepayerNo}}</td>
                </tr>
                <tr>
                  <td class="btbg font-center" rowspan="3">*开票内容</td>
                  <td class="btbg font-center">开票方式</td>
                  <td class="btbg font-center">开票项目</td>
                  <td class="btbg font-center">含税金额(元)</td>
                  <td class="btbg font-center">票据种类</td>
                  <td class="btbg" colspan="3">业务类型:{{appInfo.businessTypeId}}</td>
                </tr>
                <tr rowspan="3">
                  <td class="btbg font-center">{{appInfo.billingMethod}}</td>
                  <td class="btbg font-center">外包服务费</td>
                  <td class="btbg font-center"></td>
                  <td class="btbg font-center">专票</td>
                  <td class="btbg" colspan="3">
                    <p>营业地址:{{appInfo.businessAddress}}</p>
                    <p>电话:{{appInfo.telephone}}</p>
                    <p>开户行账号:{{appInfo.bankOfDeposit}}</p>
                  </td>
                </tr>
                <tr>
                  <td class="btbg font-center">金额合计:</td>
                  <td class="btbg" colspan="3">￥{{appInfo.sumAmountApplied}}</td>
                  <td class="btbg" colspan="3">备注{{appInfo.remark}}</td>
                </tr>
                <tr>
                  <td class="btbg" colspan="2">收票地址、联系人及电话(快递信息):</td>
                  <td class="btbg" colspan="6"></td>
                </tr>
                <tr>
                  <td class="btbg">申请开票日期:</td>
                  <td class="btbg" colspan="7">{{baseInfo.applicationTime}}</td>
                </tr>
                <tr>
                  <td class="btbg">合同附件:</td>
                  <td class="btbg" colspan="7"></td>
                </tr>
                <tr>
                  <td class="btbg">结算的附件:</td>
                  <td class="btbg" colspan="7">
                    <span v-for="(item,index) in invoiceFiles" :key="index" class="blueName cp" @click="down(item)">{{'附件' + (index== 0 ? '' : index+1)}}</span>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div class="p_employee_list">
          <div class="r_edit_title">
            <div class="line_box"></div>对应结算单
          </div>
          <div class="dtl_table">
            <el-table border :data="finalStatementViewList" style="width:100%">
              <!-- 项目或部门 -->
              <el-table-column align="center" label="项目/部门" min-width="160px">
                <template slot-scope="{row}">
                  <span>{{row.ownershipName}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="归属月" min-width="110px" fit :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                  <span>{{row.ownershipMonth}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="结算单编号" min-width="110px" fit :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                  <span>{{row.finalStatementNo}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="结算单金额" min-width="110px" fit :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                  <span>{{row.settlementAmount}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="本次开具金额" min-width="100px" fit :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                  <span>{{row.amountApplied}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="创建时间" min-width="100px" fit :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                  <span>{{row.createTime}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="附件" min-width="100px" fit :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                  <span v-if="row.fileUrl" class="blueName cp" @click="down(row.fileUrl)">下载</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <p class="d_txt">结算单本次开具发票金额小计： ￥{{ baseInfo.applyForBillingAmount }}</p>
          <div class="f_input_box" v-if="jumpType == 'resubmit'">
            <p class="f_txt">申请备注:</p>
            <div class="f_input_right">
              <el-input v-model="infoForm.StrRemark" type="textarea" rows="4" clearable></el-input>
            </div>
          </div>
        </div>
        <div class="p_employee_list mt15" v-if="type == 'part'">
          <div class="r_edit_title">
            <div class="line_box"></div>
            <span>已开发票</span>
            <div class="down_txt">下载</div>
          </div>
          <div class="p_employee_form">
            <div class="p_employee_item">
              <p class="emp_txt">发票张数:</p>
              <div class="emp_form_txt">4张</div>
            </div>
            <div class="p_employee_item">
              <p class="emp_txt">发票类型:</p>
              <div class="emp_form_txt">专票</div>
            </div>
            <div class="p_employee_item">
              <p class="emp_txt">开票方式:</p>
              <div class="emp_form_txt">全额</div>
            </div>
            <div class="p_employee_item">
              <p class="emp_txt">票种:</p>
              <div class="emp_form_txt">专票</div>
            </div>
            <div class="p_employee_item">
              <p class="emp_txt">税额:</p>
              <div class="emp_form_txt">11111</div>
            </div>
            <div class="p_employee_item">
              <p class="emp_txt">发票号码:</p>
              <div class="emp_form_txt">11112234，11113423</div>
            </div>
            <div class="p_employee_item">
              <p class="emp_txt">开票备注:</p>
              <div class="emp_form_txt">11111</div>
            </div>
            <div class="p_employee_item">
              <p class="emp_txt">开票时间:</p>
              <div class="emp_form_txt">11111</div>
            </div>
          </div>
        </div>
        <div class="btn_box">
          <el-button @click="backHandle">返回</el-button>
          <el-button v-if="jumpType == 'resubmit'" type="primary" @click="saveHandle">重新提交申请</el-button>
        </div>
      </div>
      <div class="step_box" v-if="activeName == 'second'">
        <el-steps direction="vertical" :active="1" space="100px">
          <el-step title="提交申请"></el-step>
          <el-step title="发票待办"></el-step>
          <el-step title="审批退回" description=""></el-step>
        </el-steps>
      </div>
      <div class="p_employee_box" v-if="activeName == 'third'">
        <div class="record_list">
          <div class="record_item">
            <p>时间：2020-02-19 12:40:45</p>
            <p>记录：申请人 提交</p>
            <p>处理人: 李四</p>
            <p>备注：XXXXXXX</p>
          </div>
          <div class="record_item">
            <p>时间：2020-02-19 12:40:45</p>
            <p>记录：申请人 提交</p>
            <p>处理人: 李四</p>
            <p>备注：XXXXXXX</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import xz from "@/common"
  import moment from 'moment'
  import print from 'print-js'
  export default {
    name: "updatePost",
    data() {
      return {
        active: 'first',
        baseInfo: {},
        infoForm: {
          StrRemark: ''
        },
        loading: false,
        isEdit: 'dtl',
        // 详情参数
        dtlQuery: {
          mainuserid: '',
          useridr: ''
        },
        tableData: [],
        jumpType: 'part',
        type: '',
        id: '',
        appInfo: {}, //f发票信息
        finalStatementViewList: [], //对应结算单
        invoiceFiles: [], //结算单附件
        activeName:'',
        isOver:false,
      }
    },
    created() {
      if (this.$route.query.id != undefined && this.$route.query.id) {
        this.id = this.$route.query.id;
        this.type = this.$route.query.type;
        this.activeName = this.$route.query.activeName
        this.GetInvoiceApplyForView()
      }
    },
    methods: {
      handleClick(tab) {
        this.activeName = tab.name
      },
      //打印
      printClick(id, ignoreIds) {
        const style = '.page {margin:0 10mm};' //打印时去掉眉页眉尾
        setTimeout(function () {
          printJS({
            printable: id, // 标签元素id
            type: 'html',
            targetStyles: ['*'],
            style: `.page{margin:10px;height:2000px};table{border-collapse:separate}`,
          });
        }, 500)
        //各个配置项
        //printable:要打印的id。
        //type:可以是 html 、pdf、 json 等。
        //properties:是打印json时所需要的数据属性。
        //gridHeaderStyle和gridStyle都是打印json时可选的样式。
        //repeatTableHeader:在打印JSON数据时使用。设置为时false，数据表标题将仅在第一页显示。
        //scanStyles:设置为false时，库将不处理应用于正在打印的html的样式。使用css参数时很有用，此时自己设置的原来想要打印的样式就会失效，在打印预览时可以看到效果
        //targetStyles: [’*’],这样设置继承了页面要打印元素原有的css属性。
        //style:传入自定义样式的字符串，使用在要打印的html页面 也就是纸上的样子。
        //ignoreElements：传入要打印的div中的子元素id，使其不打印。非常好用
      },
      // 提交申请开票
      saveHandle() {

      },
      // 取消
      backHandle() {
        this.$router.push({
          path: "/invoicing",
        });
      },
      isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN'
      },
      //获取详情
      GetInvoiceApplyForView() {
        this.loading = true;
        xz.GetInvoiceApplyForView(this.id).then(res => {
          if (res.status == 'ok') {
            if (res.data.length > 0) {
              this.baseInfo = res.data[0];
              this.loading = false;
              if (res.data[0].invoiceRequisitionViewList.length > 0) {
                this.appInfo = res.data[0].invoiceRequisitionViewList[0];
              }
              this.finalStatementViewList = res.data[0].finalStatementViewList;
              this.invoiceFiles = res.data[0].invoiceFiles;
              this.isOver = true;
            } else {
              this.loading = false;
              this.$meseage.error('获取详情出错')
            }
          } else {
            this.loading = false;
            this.$meseage.error(res.msg)
          }
        })
      },
      down(url) {
        d = url.replace("\"", "").replace("\"", "");
        var path = this.$store.state.EMP.docPath + d;
        const aTag = document.createElement('a')
        aTag.href = path
        aTag.click();
      }
    }
  }
</script>
<style scoped>
  .down_txt {
    font-size: 14px;
    color: #409EFF;
    margin-left: 20px;
  }

  .record_item {
    padding: 10px;
    color: #555;
    font-size: 14px;
    box-shadow: 0px 4px 6px 0px rgba(104, 11, 255, 0.02);
    background-color: #f2f3f3;
    margin-bottom: 10px;
  }

  .mt15 {
    margin-top: 15px;
  }

  .record_item p {
    margin-top: 5px;
  }

  .s_tabs_box {
    background-color: #fff;
  }

  .step_box {
    background-color: #fff;
    padding: 15px 10px;
    min-height: 300px;
  }

  .f_input_box {
    display: flex;
    margin-top: 20px;
  }

  .f_txt {
    width: 80px;
    font-size: 14px;
    color: #555;
  }

  .f_input_right {
    flex: 1;
  }

  .print_box {
    justify-content: flex-end;
  }

  .centerTitle {
    width: 100%;
    /* margin-bottom: 5px; */
    border: 1px solid #000;
    border-bottom: none;
    text-align: center;
    font-weight: bold;
    font-size: 24px;
    box-sizing: border-box;
  }

  .com_form_box {
    margin: 15px 0;
  }

  .tabtop td {
    background-color: #ffffff;
    height: 30px;
    line-height: 150%;
  }

  .font-center {
    text-align: center
  }

  .titfont {
    font-family: 微软雅黑;
    font-size: 16px;
    font-weight: bold;
  }

  .d_txt {
    font-size: 14px;
    color: #555;
    margin-top: 20px;
  }

  .btn_box {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }

  .line_box {
    width: 3px;
    height: 16px;
    background-color: #19bd92;
    margin-right: 4px;
  }

  .dtl_table {
    box-sizing: border-box;
    margin-top: 15px;
  }

  .emp_txt {
    width: 120px;
    text-align: right;
    font-size: 14px;
    color: #555;
    padding: 0 10px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .r_edit_title {
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 26px;
    font-weight: bold;
    color: #000;
    /* border-bottom: 1px solid #DCDFE6; */
  }

  .emp_form_txt {
    width: 360px;
    font-size: 14px;
    color: #000;
  }

  .txts01 {
    font-size: 14px;
  }

  .p_employee_item {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    margin-right: 3px;
  }

  .p_employee_form {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
  }

  .p_employee_box {
    background-color: #fff;
    padding: 15px 10px;
  }
</style>
<style>
  .s_submit_content .dtl_table .el-table,
  .s_submit_content .el-table th.el-table__cell {
    background-color: #E8F7F7;
    /* 你想要的背景色 */
  }

  .form_table td {
    border: #000 1px solid;
  }

  .e_dtl_content .el-table .el-table__cell {
    padding: 4px 0;
  }
</style>